import { CartApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { CartTotalsA } from './CartTotalsA';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface CartTotalsProps {
  cart: CartApiDto;
}

export type CartTotalsVariants = 'A';

const CartTotalsController = (props: PropsWithCustomComponent<CartTotalsProps>) => (
  <VariantsController<CartTotalsProps, CartTotalsVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: CartTotalsA },
      defaultComponent: CartTotalsA,
      name: 'CartTotals',
    }}
  />
);
export { CartTotalsController as CartTotals };
